<template>
  <div class="availability-reminder">
    <template v-if="loggedIn">
      <div v-if="!subscribeMe">
        <checkbox
          v-model="subscribeMe"
          name="remindMe"
          type="checkbox"
          :label="$t('product.reminder.availability.notSubscribed')"
          @change="onChange"
        />
      </div>
      <div
        v-else
        class="availability-reminder__success"
        v-html="$t('product.reminder.availability.subscribed')"
      />
    </template>
    <template v-else>
      <checkbox
        name="remindMeGuest"
        type="checkbox"
        :label="$t('product.reminder.availability.notSubscribed')"
        @change="onChangeGuest"
      />
      <div
        class="availability-reminder__info"
        v-if="subscribeMeGuest"
        v-html="$t('product.reminder.availability.guest.notSubscribed')"
        @click="logMeIn"
      />
    </template>
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import httpRequest from '../../utilities/js/httpRequest/httpRequest';
  import jsGlobalConfig from '../../globals/jsGlobalConfig';
  import Checkbox from '../checkbox/checkbox.vue';
  import {TrackingService} from '../../services/tracking/TrackingService';

  @Options({
    name: 'availability-reminder',
    components: {
      Checkbox
    }
  })
  export default class AvailabilityReminder extends Vue {

    @Prop()
    itemId: string;

    @Prop()
    subscribed!: boolean;

    @Prop()
    loggedIn: boolean;

    @Prop()
    loginPageUrl: string;

    subscribeMe: boolean = this.subscribed;
    subscribeMeGuest: boolean = false;

    onChange() {
      const data = 'itemId=' + this.itemId;
      httpRequest('/availability/reminder/', {
        method: 'POST',
        headers: jsGlobalConfig().getCsrfTokenHeader(),
        data: data
      }).then(() => {
        this.subscribeMe = true;
        TrackingService.trigger(TrackingService.EVENT_GENERIC, {
          event: 'mail.wiederverfuegbarkeit'
        });
      });
    }

    onChangeGuest() {
      this.subscribeMeGuest = true;
    }

    logMeIn() {
      window.location.href = this.loginPageUrl + '?reminderItemId=' + this.itemId;
    }
  }

</script>
